import { Chip } from "@mui/material"
import type { FC } from "react"

import { EQUIVALENCY_TYPE_COLORS, EQUIVALENCY_TYPE_LABELS } from "../constants"

import type { EquivalencyType } from "@/graphql/codegen/graphql"

interface EquivalencyTypeChipProps {
  type: EquivalencyType
}

export const EquivalencyTypeChip: FC<EquivalencyTypeChipProps> = ({ type }) => {
  return (
    <Chip
      label={EQUIVALENCY_TYPE_LABELS[type]}
      size='small'
      variant='filled'
      className={`rounded-2xl text-xs text-gray-900 ${EQUIVALENCY_TYPE_COLORS[type]}`}
      data-testid={`type-chip-${EQUIVALENCY_TYPE_LABELS[type].toLowerCase()}`}
    />
  )
}
